<template>
  <div class="footer" id="footer">
      <div class='footer_container'>
        <div class='copyright'><p v-html="copyright"></p></div>
        <div class='links'>
            Links of PMG Lab's Tools:<br/>
            <div v-for="(li,idx) in links" :key="idx">
             <a  :href="li.url" target="_blank">{{li.name}} </a><p v-if="idx<links.length-1">| </p>
            </div>
            <br>
            <!-- <a  :href="web_visitor.link" target="_blank"> {{web_visitor.name}}</a> -->
            <a href="https://www.revolvermaps.com/livestats/5k7dlznlcbb/"><img class='visitor_img' src="//rf.revolvermaps.com/w/3/s/a/5/0/0/007eff/010020/aa0000/5k7dlznlcbb.png" alt="Stats" style="border:0;"></a>
        </div>
        <!-- <div class='img_container'>
            <a v-for="it in logos" :href="it.link" target="_blank">
                <img class="link_img" :src="it.url"/>
            </a>
        </div> -->
      </div>
  </div>
</template>

<script>
import {common_api_dir} from '@/bus.js'
import axios from 'axios/dist/axios.min';
export default {
  name: 'footer',
  data:function(){
    var base_url='https://pmglab.top'
        return { 
            links: [
                {name:'KGG',url:base_url+'/kgg'},
                {name:'KGGSeq',url:base_url+'/kggseq'},
                {name:'KGGSEE',url:base_url+'/kggsee'},
                {name:'PCGA',url:base_url+'/pcga'},
                {name:'REZ',url:base_url+'/rez'},
                {name:'FAPI',url:base_url+'/fapi'},
                {name:'SnpTracker',url:base_url+'/snptracker'},
                {name:'IGG',url:base_url+'/igg'},
            ],
            copyright:
                'Precision Medicine Genomics Laboratory (精准医学基因组学实验室)</br>\
                Zhongshan School of Medicine</br>\
                Sun Yat-sen University</br>\
                Copyright © 2022',
            web_visitor:{
                link:'',
                name:'Web visitors'
            }
        }
    },
    mounted () {
        // this.getData()
    },
    methods:{
        getData(){
            var _this=this
            _this.links=[]
            axios.get(common_api_dir+'info.php',{
                params:{
                    type:'links',
                }
            })
            .then(function (response) {
                var jsonObj = JSON.parse(JSON.stringify(response.data));
                var links=jsonObj
                for(let i=1;i<links.length;i++){
                    _this.links.push({'name':links[i][0],'url':links[i][1]})
                }
            })
            .catch(function (error) {
                console.log(error);
            });
        },
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.footer{
    height: 80px;
    background: #005826;
    width:1200px;
    position: relative;
    left: 0px;
    margin:100px 0px 0px 0px;
    padding: 0;

}
.footer_container {
        background: #005826;
}

.copyright{
    float: left;
    width: 500px;
    text-align: left;
    font-size: 13px;
    padding-left: 40px;
    margin-right: 20px;
    color:  #EEEEEE;
    line-height: 15px;
    height: 100px;
}

.copyright p{
    margin:10px 0px;
}

.links{
    float: left;
    width: 500px;
    text-align: left;
    color:  #EEEEEE;
    margin: 10px 0px; 
    font-size: 15px;
}
.links div{
    display: inline;
}

.links a{
    color:  #EEEEEE;
    /* display: block; */
    /* padding-left: 40px; */
    font-size: 14px;
    text-decoration: none;
}

.links a:hover{
    color:#428bca;
}

.links p{
    display: inline;
}


.link_img{
    float: left;
    height: 40px;
    padding: 30px 20px;
}


.visitor_img{
    margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/footer.vue